module.exports = __webpack_public_path__ + "img/chadle3_4.1721efd2.png";